import type { Metadata } from "@/lib/head";

import ToolIntro from "@/pages/tools/_ui/tool-intro";
import OhouseCalculator from "@/pages/tools/ohouse-cost/ohouse-calculator";

export const metadata: Metadata = {
  title: "오늘의집 광고비 계산기 — 계약 1건당 광고비",
  description:
    "오늘의집 월 광고비를 계약 건수로 나눠 계약 1건에 드는 광고비, 계약금액 대비 비율, 자사 채널로 온 계약 1건이 광고비 몇 원어치인지 사장님 숫자로 계산합니다.",
};

// 오늘의집 광고비 계산기 — 빌드파이 요금은 넣지 않는다.
const OhouseCostPage = () => (
  <div className="flex flex-col gap-4">
    <ToolIntro
      description="월 광고비 ÷ 계약 건수 — 계약 1건이 광고비를 얼마나 먹는지 사장님 숫자로 봅니다."
      title="오늘의집 광고비 계산기"
    />
    <OhouseCalculator />
  </div>
);

export default OhouseCostPage;
